import React from 'react';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import {isCategoryParticipantsFilterTabActive} from '../../EventParticipantsHeader/ParticipantsTabs/CategoryFilterParticipants/isCategoryParticipantsFilterTabActive';
import {isFavoriteParticipantsFilterTabActive} from '../../EventParticipantsHeader/ParticipantsTabs/FavoriteParticipants/isFavoriteParticipantsFilterTabActive';
import {isMyContactsFilterTabActive} from '../../EventParticipantsHeader/ParticipantsTabs/MyContacts/isMyContactsFilterTabActive';
import {isTextSearchFilterTabActive} from '../../EventParticipantsHeader/ParticipantsTabs/TextSearchParticipants/isTextSearchFilterTabActive';
import styles from './EmptyParticipantsListMessage.module.scss';

function EmptyParticipantsListMessage(props) {
    const {filterParams, suggestedFilterParams} = props,
        i18n = useI18n();

    let message;

    if (isFavoriteParticipantsFilterTabActive(filterParams)) {
        message = i18n['start.view_favorites.disabled'];
    } else if (isMyContactsFilterTabActive(filterParams)) {
        message = i18n['start.view_my_connections.disabled'];
    } else if (isTextSearchFilterTabActive(filterParams)) {
        message = i18n['label.no-participants-matching-your-query'];
    } else if (isCategoryParticipantsFilterTabActive(filterParams, suggestedFilterParams)) {
        message = i18n['label.no-participants-matching-your-filter'];
    } else {
        message = i18n['label.no-participants-listed-at-the-moment'];
    }

    if (!message) return null;

    return <div className={styles.EmptyParticipantsListMessage}>{message}</div>;
}

export default EmptyParticipantsListMessage;
